export default "__VITE_ASSET__CuoRdF9F__";